import { render, staticRenderFns } from "./system-config.vue?vue&type=template&id=7d0709b5&scoped=true"
import script from "./system-config.ts?vue&type=script&lang=ts&external"
export * from "./system-config.ts?vue&type=script&lang=ts&external"
import style0 from "./system-config.scoped.scss?vue&type=style&index=0&id=7d0709b5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0709b5",
  null
  
)

export default component.exports